/* global Fw, actionPath, tinyMCE */
(function () {
    'use strict';

    var recaptcha;
    var validateForm;
    var successTimeout;
    var pminoInputs;

    var formSent = function (response, form) {
        if (response.indexOf('success') !== -1) {
            var successMessage = $('.js-form-success-message.contact-form-sent', form);

            form.removeClass('is-checked');
            form.find('.has-value, .success').removeClass('has-value success')
                    .val('');
            try {
                form[0].reset();
            } catch (err) {
                console.error(err);
            }

            successMessage.slideDown(300, function () {
                grecaptcha.reset();

                clearTimeout(successTimeout);
                successTimeout = setTimeout(function () {
                    successMessage.slideUp(300);
                }, 5000);
            });
        }
    };

    var sendContactFormEmailClass = function (captcha, form) {
        var t = $(this);
        var count = t.data('count');
        var subjectInput = $('.contactForm-subject', form);
        var subject = subjectInput.val();
        var email = $('.contactForm-email', form).val();
        var content = null;

        try {
            content = tinyMCE.get('contactForm-content', form).getContent();
        } catch (exception) {
            content = $('.contactForm-content', form).val();
        }

        var appendField = "";
        if ($('.fieldName1', form).length) {
            var total = 9;
            if (count) {
                total = count;
            }
            for (var i = 1; i < total; i++) {
                appendField += "&fieldName" + i + "=" +
                        encodeURIComponent($('.fieldName' + i, form).val());
                if ($('.field' + i, form).attr('type') == "checkbox") {
                    if ($('.field' + i, form).checked) {
                        appendField += "&field" + i + "=checked.";
                    } else {
                        appendField += "&field" + i + "=not checked.";
                    }
                } else {
                    appendField += "&field" + i + "=" +
                            encodeURIComponent($('.field' + i, form).val());
                }
            }
            appendField += "&count=" + total;
        }
        if (captcha) {
            appendField += '&captcha=' + captcha;
        }

        var sendCopyUser = $('[name=sendCopyUser]', form).val();
        if (sendCopyUser) {
            appendField += '&sendCopyUser=' + sendCopyUser;
        }

        var targetEmail = $('[name=targetEmail]', form).val();
        if (targetEmail) {
            appendField += '&targetEmail=' + targetEmail;
        }

        var identifier = $('[name=identifier]', form).val();
        if (identifier) {
            appendField += '&identifier=' + identifier;
        }

        if (subjectInput.prop('tagName') === 'SELECT') {
            var directEmail = subjectInput.find('option[value="' + subject + '"]').attr('data-email');

            if (directEmail.length > 0) {
                appendField += '&directEmail=' + directEmail;
            }
        }

        console.log(actionPath + "contactUs?subject=" + encodeURIComponent(subject) +
        "&email=" + encodeURIComponent(email) +
        "&content=" + encodeURIComponent(content) +
        appendField)

        ajax(actionPath + "contactUs?subject=" + encodeURIComponent(subject) +
                "&email=" + encodeURIComponent(email) +
                "&content=" + encodeURIComponent(content) +
                appendField, formSent, false, form);
    };

    var sendContactUsAttachmentDyn = function (captcha, form) {
        var formdata = new FormData(form[0]);

        formdata.append('ajaxForm', 'true');
        formdata.append('captcha', captcha);

        $.ajax({
            method: 'post',
            type: 'post',
            url: actionPath + 'contactUsAttachmentDyn',
            data: formdata,
            cache: false,
            contentType: false,
            processData: false,
            success: function (res) {
                if (res.indexOf('success') !== -1) {
                    form.removeClass('is-checked');
                    form.find('.has-value, .success').removeClass('has-value success')
                            .val('');

                    $('.js-form-success-hide', form).slideUp(300);
                    $('.js-form-success-message.contact-form-sent', form).slideDown(300, function () {
                        grecaptcha.reset();
                    });
                }
            }
        });
    };

    var appendFieldContent = function (name, value) {
        var x = value ? value : '';
        if (value.match(/^[a-zA-Z0-9.!#$%&�*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
            x = '<a href="mailto:' + value + '" target="_blank">' + value + '</a>';
        }
        return '<p><strong>' + name + ' - </strong>' + x + '</p>';
    };

    var sendPhoenixForm = function (captcha, form) {
        var content = '';

        // Email
        var emailInput = $('.contactForm-email', form);
        if (emailInput.length) {
            content += appendFieldContent(emailInput.attr('title'), emailInput.val());
        }
        
        // Fields
        var i = 1;
        while ($('.fieldName' + i).length) {
            var curFieldName = $('.fieldName' + i);
            var curField = $('.field' + i);

            if (curField.attr('type') === 'checkbox' || curField.attr('type') === 'radio') {
                var vals = [];
                if (curField.length > 1) {
                    curField.filter(':checked').each(function() {
                        vals.push(this.value);
                    });
                } else {
                    var val = curField.val();
                    if (val && val !== "") {
                        vals[0] = val;
                    } else {
                        vals[0] = curField.prop('checked') ? 'checked' : 'unchecked';
                    }
                }
                content += appendFieldContent(curFieldName.val(), vals.join(', '));
            } else {
                content += appendFieldContent(curFieldName.val(), curField.val());
            }
            i++;
        }
        
        // Contact subject
        var subjectInput = $('.contactForm-subject', form);
        if (subjectInput.length) {
            content += appendFieldContent('Subject', subjectInput.val());
        }
        
        // Message content
        var messageInput = $('.contactForm-content', form);
        if (messageInput.length) {
            try {
                content += appendFieldContent('Message', tinyMCE.get('contactForm-content', form).getContent());
            } catch (err) {
                content += appendFieldContent('Message', messageInput.val());
            }
        }
        
        content += '<p>&nbsp;</p>';
        // Add user record
        if ($('.phxkbz-fname', form).length) {
            content += appendFieldContent('Submitter First Name', $('.phxkbz-fname', form).val());
        }
        if ($('.phxkbz-lname', form).length) {
            content += appendFieldContent('Submitter Last Name', $('.phxkbz-lname', form).val());
        }
        if ($('.phxkbz-email', form).length) {
            content += appendFieldContent('Submitter Email', $('.phxkbz-email', form).val());
        }
        content += appendFieldContent('Source', '<a href="' + window.location.href + '" target="_blank">' + window.location.href + '</a>');

        // Build the query
        var q = 'ajax=true&captcha=' + captcha;
        q += '&title=' + encodeURIComponent($('.phxkbz-title', form).val());
        q += encodeURIComponent(' - ' + $('.input-firstname', form).val() + ' ' + $('.input-lastname', form).val());
        q += '&labelId=' + encodeURIComponent($('.phxkbz-label-id', form).val());
        q += '&description=' + encodeURIComponent(content);
        
        // Submit the data
        ajax(actionPath + "pmiKanBanZone?" + q, formSent, false, form);
    };

    var updateTargetEmail = function(t) {
        var t = $(this);
        var form = t.closest('.contactForm-Container');
        var option = $(this).find('option:selected');
        
        $('.directEmail', form).val(option.attr('data-email'));
    };
    
    var verifyMemberId = function(captcha, form, identifier, callback) {
        var btn = $(this);
        // Disable submit button
        btn.addClass('disabled');

        // Verify chapter member id
        var res = 'error';
        var inp = $(pminoInputs, form)[0];
        var data = {
            captcha: captcha,
            adelaide: true,
            verifyMemberNumber: inp.value,
            formId: identifier,
            formField: inp.name
        };
        
        $.ajax({
            url: actionPath + 'pmiAccount',
            method: 'get',
            type: 'get',
            data: data,
            success: function(response) {
                res = response;
            },
            complete: function() {
                if (res.indexOf('success') !== -1) {
                    // Verified
                    form.find('.error-msg.not-permitted').slideUp(300);
                    callback.call(btn[0], captcha, form, identifier);
                } else {
                    // Invalid
                    grecaptcha.reset();
                    btn.removeClass('disabled');
                    form.find('.error-msg.not-permitted').slideDown(300);
                }
            }
        });
    };
    
    var submitFormAdelaide = function(btn, captcha, form, identifier, count, subject, targetEmail, email) {
        var appendField = '';
        
        // Disable submit button
        btn.addClass('disabled');
        
        appendField += 'subject=' + encodeURIComponent(subject);
        appendField += '&targetEmail=' + encodeURIComponent(targetEmail);
        appendField += '&identifier=' + encodeURIComponent(identifier);
        appendField += '&email=' + encodeURIComponent(email);
        appendField += '&content='; // If "content" param was not set, "null" text would appear in the email
        appendField += '&count=' + count;
        for (var i = 1; i < count; i++) {
            appendField += '&fieldName' + i + '=' +
                encodeURIComponent($('.fieldName' + i, form).val());

            var type = $('.field' + i, form).attr('type');
            if (type === 'checkbox' || type === 'radio') {
                var x = [];
                $('.field' + i, form).each(function(i, el) {
                    if (el.checked) {
                        x.push(el.value);
                    }
                });
                appendField += '&field' + i + '=' +
                    encodeURIComponent(x.join(','));
            } else {
                appendField += '&field' + i + '=' +
                    encodeURIComponent($('.field' + i, form).val());
            }
        }
        if (captcha) {
            appendField += '&captcha=' + captcha;
        }
        
        var res = 'error';
        $.post({
            url: actionPath + 'contactUs',
            data: appendField,
            cache: false,
            success: function(response) {
                res = response;
            },
            complete: function() {
                if (res.indexOf('success') !== -1) {
                    $('.js-form-success-hide', form).slideUp(300, function() {
                        $('.js-form-success-message.contact-form-sent', form).slideDown(300);
                    });
                } else {
                    btn.removeClass('disabled');
                    alert('Failed. Something went wrong.');
                }
            }
        });
    };
    
    var submitAttachmentFormAdelaide = function(btn, captcha, form, identifier, count, targetEmail) {
        var formdata = new FormData(form[0]);
        
        // Disable submit button
        btn.addClass('disabled');
        
        formdata.append('ajaxForm', 'true');
        if (captcha) {
            formdata.append('captcha', captcha);
        }
        formdata.append('targetEmail', targetEmail);
        formdata.append('identifier', identifier);
        formdata.append('content', ''); // If "content" param was not set, "null" text would appear in the email
        formdata.append('count', count);
        
        var res = 'error';
        $.post({
            url: actionPath + 'contactUsAttachmentDyn',
            data: formdata,
            cache: false,
            contentType: false,
            processData: false,
            success: function(response) {
                res = response;
            },
            complete: function() {
                if (res.indexOf('success') !== -1) {
                    $('.js-form-success-hide', form).slideUp(300, function() {
                        $('.js-form-success-message.contact-form-sent', form).slideDown(300);
                    });
                } else {
                    btn.removeClass('disabled');
                    alert('Failed. Something went wrong.');
                }
            }
        });
    };
    
    var sendAdelaideVoteForm = function(captcha, form, identifier) {
        submitFormAdelaide($(this), captcha, form, identifier, 4, $('.contactForm-subject', form).val(), 'adelaide.vote', '-');
    };
    
    var sendAdelaideNominationForm = function(captcha, form, identifier) {
        submitAttachmentFormAdelaide($(this), captcha, form, identifier, 15, 'adelaide.vote');
    };
    
    var sendAdelaideEBallotForm = function(captcha, form, identifier) {
        submitFormAdelaide($(this), captcha, form, identifier, 3, $('.contactForm-subject', form).val(), 'adelaide.vote', form.find('input[name=email]').val());
    };

    var init = function (page) {
        recaptcha = Fw.component.models().utils.recaptcha;
        validateForm = Fw.component.models().form.validateForm;
        
        pminoInputs = $('.input-pmi-number');

        $('.contactForm-subject').on('change', updateTargetEmail);

        $('.submit-contact-form-btn').each(function () {
            recaptcha(this, function (response, form, btn) {
                sendContactFormEmailClass.call(btn, response, form);
            }, true, $(this).closest('.contactForm-Container'));
        });

        $('.submit-contactattdyn-form-btn').each(function () {
            recaptcha(this, function (response, form, btn) {
                sendContactUsAttachmentDyn.call(btn, response, form);
            }, true, $(this).closest('.contactForm-Container'));
        });
        
        $('.submit-phxkbz-form-btn').each(function () {
            recaptcha(this, function (response, form, btn) {
                sendPhoenixForm.call(btn, response, form);
            }, true, $(this).closest('.contactForm-Container'));
        });
        
        $('.submit-adelaide-vote-form-btn').each(function () {
            recaptcha(this, function (response, form, btn) {
                verifyMemberId.call(btn, response, form, 'adelaide-vote', sendAdelaideVoteForm);
            }, true, $(this).closest('.contactForm-Container'));
        });
        
        $('.submit-adelaide-nomination-form-btn').each(function () {
            recaptcha(this, function (response, form, btn) {
                verifyMemberId.call(btn, response, form, 'adelaide-nomination', sendAdelaideNominationForm);
            }, true, $(this).closest('.contactForm-Container'));
        });
        
        $('.submit-adelaide-e-ballot-form-btn').each(function () {
            recaptcha(this, function (response, form, btn) {
                verifyMemberId.call(btn, response, form, 'adelaide-e-ballot', sendAdelaideEBallotForm);
            }, true, $(this).closest('.contactForm-Container'));
        });
    };

    $(init);

    Fw.component.export('sendContactForm', {
        sendContactFormEmailClass: sendContactFormEmailClass
    });

})();
